import { apiGateway } from "@/shared/apiGateway";

const getDashboard = (context, { clientId, contractorRegionId }) => {
  var url = "api/dashboard/?dash=1";
  if (clientId !== undefined) {
    url = url + "&clientId=" + clientId;
  }
  if (contractorRegionId !== undefined) {
    url = url + "&contractorRegionId=" + contractorRegionId;
  }
  return apiGateway
    .apiGatewayGET(url)
    .then(data => {
      context.commit(
        "REPORT_SETPLANTWITHOUTSTATINSPCHARTDATA",
        data.dashboardCharts.plantWithoutStatInsp
      );
      context.commit(
        "REPORT_SETTIMEDDEFECTSTATUSESCHARTDATA",
        data.dashboardCharts.timedDefectStatus
      );
      context.commit(
        "REPORT_SETUNTIMEDDEFECTSTATUSESCHARTDATA",
        data.dashboardCharts.untimedDefectStatus
      );
      context.commit(
        "REPORT_SETSAFEDSTATUSESCHARTDATA",
        data.dashboardCharts.safedStatus
      );
      context.commit(
        "REPORT_SETSTATINSPSTATUSESCHARTDATA",
        data.dashboardCharts.statInspStatus
      );
      context.commit("set_queried_metric", data.metrics.queriedMetric);
      context.commit("set_quote_metric", data.metrics.quoteMetric);
    })
    .catch(error => {
      console.error(error);
      context.dispatch("SHOW_ERROR_ALERT", ["Error getting Dashboard"], {
        root: true
      });
    });
};

const getActivePlantReport = (context, { clientId }) => {
  var url = "api/reports/active-plant";
  if (clientId !== "0") {
    url = url + "?clientId=" + clientId;
  }
  apiGateway.apiGatewayBLOB(url).catch(error => {
    console.error(error);
    context.dispatch(
      "SHOW_ERROR_ALERT",
      ["Error getting Active Plant Report"],
      { root: true }
    );
  });
};

const getActivePlantSummaryReport = context => {
  var url = "api/reports/active-plant-summary";
  apiGateway.apiGatewayBLOB(url).catch(error => {
    console.error(error);
    context.dispatch(
      "SHOW_ERROR_ALERT",
      ["Error getting Plant Summary Report"],
      { root: true }
    );
  });
};

const getClientActivePlantSummaryReport = (context, { clientId }) => {
  var url = "api/reports/client-active-plant-summary?clientId=" + clientId;
  apiGateway.apiGatewayBLOB(url).catch(error => {
    console.error(error);
    context.dispatch(
      "SHOW_ERROR_ALERT",
      ["Error getting Plant Summary Report"],
      { root: true }
    );
  });
};

const getClientStatInspReport = (context, { clientId }) => {
  var url = "api/reports/stat-insps-by-client-details";
  if (clientId !== undefined) {
    url = url + "?clientId=" + clientId;
  }
  apiGateway.apiGatewayBLOB(url).catch(error => {
    console.error(error);
    context.dispatch(
      "SHOW_ERROR_ALERT",
      ["Error getting Client Stat Insp Report"],
      { root: true }
    );
  });
};

const getContractorStatInspItemReport = (
  context,
  { contractorRegionId, clientId }
) => {
  var url = "api/reports/stat-insps-by-contractor-details";
  if (contractorRegionId !== undefined) {
    url = url + "?contractorRegionId=" + contractorRegionId;
    if (clientId !== undefined) {
      url = url + "&clientId=" + clientId;
    }
  }
  apiGateway.apiGatewayBLOB(url).catch(error => {
    console.error(error);
    context.dispatch(
      "SHOW_ERROR_ALERT",
      ["Error getting Stat. Insps. for contractor report"],
      { root: true }
    );
  });
};

export default {
  getDashboard,
  getActivePlantReport,
  getClientActivePlantSummaryReport,
  getClientStatInspReport,
  getContractorStatInspItemReport,
  getActivePlantSummaryReport
};
